import { render } from "./list.vue?vue&type=template&id=2d3d3043&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"

import "./list.vue?vue&type=style&index=0&id=2d3d3043&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2d3d3043"

export default script